import { MarkdownContent } from '@localagent/ui';
import type { LiveLlmCall } from '@localagent/sdk';

export function StreamingAnswer({ call }: { call: LiveLlmCall }) {
  return (
    <div
      data-testid="streaming-answer"
      data-settled={call.settled ? 'true' : 'false'}
      className="mr-auto w-full max-w-2xl rounded-lg px-4 py-2"
    >
      <MarkdownContent content={call.content} />
    </div>
  );
}
